import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FileUploadModule } from '../file-upload/file-upload.module';
import { MediaBankFileUploadDetailModule } from '../../media-bank/media-bank-file-upload-detail/media-bank-file-upload-detail.module';
import { LinkToModule } from '../../shared/link-to/link-to.module';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FiTextItemMediaPanelHandlerModule } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-handler.module';
import { FiImageMediaPanelModule } from '@fi-app/utilities/insert-media/fi-image-media-panel/fi-image-media-panel-handler.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        FileUploadModule,
        MediaBankFileUploadDetailModule,
        LinkToModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        FiTextItemMediaPanelHandlerModule,
        FiImageMediaPanelModule,
    ],
    declarations: [],
    providers: [],
})
export class InsertMediaModule {}
